import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/recruitment-management-systems/resume-parsing/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "resume-parsing" entry is kept); the seo block below is a fallback.

export const resumeParsing: ContentPage = {
  slug: "recruitment-management-systems/resume-parsing",
  template: "hrmsFeature",
  seo: {
    title: "Streamline Screening with AI Resume Parsing",
    description: "Automate candidate data extraction with our AI-driven resume parsing tool, enhancing recruitment efficiency and accuracy.",
    keywords: [
      "resume parsing",
      "AI recruitment tools",
      "automated data extraction",
      "candidate screening software",
      "ATS integration.",
    ],
    ogImage: "/assets/data/seoimages/resume-parsing.webp",
  },
  leaf: {
    hero: {
      caption: "Resume Parsing",
      title: "Accelerate Candidate Screening with Advanced Resume Parsing",
      description: "Extract and analyze candidate information efficiently with our AI-driven resume parsing technology, speeding up the recruitment process.",
      h1: "caption",
    },
    split: {
      title: "Streamline Candidate Evaluation",
      bullets: [
        { title: "AI-Driven Data Extraction", description: "Automatically pull relevant data from resumes swiftly." },
        { title: "Data Normalization", description: "Standardize information across various resume formats." },
        { title: "Seamless ATS Integration", description: "Feed parsed data directly into the applicant tracking system." },
        { title: "Enhanced Candidate Sorting", description: "Improve sorting and searching capabilities for candidates." },
      ],
      image: "/assets/images/img/product/hrms/recruitmentms/resume-parsing_info.webp",
      imageAlt: "resume-parsing_info",
    },
    cardsHeading: {
      title: "Key Features of Recruitment Management System",
      description: "Optimize Recruitment Management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Multi-Platform Job Posting",
        href: "/hrms-software/recruitment-management-systems/multi-platform-job-posting/",
        description: "Expand your talent search by posting jobs simultaneously across multiple job boards and social media platforms with a single click.",
        image: "/assets/images/img/product/hrms/recruitmentms/multi-platform-job-posting.webp",
        imageAlt: "multi-platform-job-posting",
      },
      {
        title: "Candidate Communication",
        href: "/hrms-software/recruitment-management-systems/candidate-communication/",
        description: "Keep candidates informed and engaged throughout the recruitment process with automated, personalized communication tools.",
        image: "/assets/images/img/product/hrms/recruitmentms/candidate-communication_image.webp",
        imageAlt: "candidate-communication",
      },
      {
        title: "Interview Management",
        href: "/hrms-software/recruitment-management-systems/interview-management/",
        description: "Coordinate and manage candidate interviews efficiently with our comprehensive interview management system, optimizing your recruitment process.",
        image: "/assets/images/img/product/hrms/recruitmentms/interview-management_image.webp",
        imageAlt: "interview-management",
      },
      {
        title: "Reporting and Analytics",
        href: "/hrms-software/recruitment-management-systems/reporting-and-analytics/",
        description: "Utilize powerful analytics and customized reports to gain insights into your recruitment process, improving decision-making and strategy.",
        image: "/assets/images/img/product/hrms/recruitmentms/reporting-and-analytics_img.webp",
        imageAlt: "reporting-and-analytics",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Optimize Your Candidate Screening Process!",
    relatedBlogsKeyword: "hrms-resume-parsing,small-business-recruitment-process",
    metaKey: "resume-parsing",
  },
  sections: [],
};
